import "core-js/modules/es7.promise.finally.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.promise.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import TeDialog from 'src/components/Dialogs/TEDialog';
import ApprovalRequest from 'src/store/models/ApprovalRequest';
import { dialog } from 'src/boot/mixins.js';
export default {
  mixins: [dialog],
  props: {
    approvalRequest: {
      type: Object
    }
  },
  components: {
    TeDialog: TeDialog
  },
  data: function data() {
    return {
      notes: ''
    };
  },
  methods: {
    approve: function approve() {
      var _this = this;

      this.showLoading();

      if (this.approvalRequest) {
        ApprovalRequest.api().approve(this.approvalRequest.approval_request_id, {
          event_notes: this.notes
        }).then(function () {
          _this.hide();
        }).finally(function () {
          _this.hideLoading();
        });
      } else {
        this.showLoading();
        ApprovalRequest.api().massApprove({
          event_notes: this.notes
        }).then(function () {
          _this.hide();
        }).finally(function () {
          _this.hideLoading();
        });
      }
    }
  }
};